import React from "react";
import { Modal } from "react-bootstrap";
import { ProgressSpinner } from "primereact/progressspinner"; // Assuming you still want to use this spinner
import "./Loader.css";

function LoadingSpinner({ loading }: { loading: boolean }) {
  if (document.getElementById("master-container-child") != null) {
    const containerGrid = document.getElementById("master-container-child");
    if (containerGrid) {
      containerGrid.style.opacity = loading ? "0.5" : "1";
    }
  }

  return (
    <Modal
      show={loading}
      centered
      backdrop="static"
      keyboard={false}
      contentClassName="spinner-wrapper"
      dialogClassName="spinner-modal"
      backdropClassName="spinner-backdrop"
    >
      <Modal.Body className="d-flex justify-content-center align-items-center">
        {/* You can use Bootstrap Spinner or keep the PrimeReact ProgressSpinner */}
        <ProgressSpinner />{" "}
        {/* You can swap this with <Spinner animation="border" /> if needed */}
      </Modal.Body>
    </Modal>
  );
}

export default LoadingSpinner;
